export const FILE_EDIT_PATH = '/file/edit';
export const DESKTOP_SHARE_MODEL_PATH = '/file/share';
